module.exports = __webpack_public_path__ + "img/angry-birds.693f1a98.png";